module.exports = __webpack_public_path__ + "static/portfolio_gallery_18-e005c27955bf5f56a69a3baabad01440.jpg";